// Vue specific modules
import Vue from 'vue';
import App from './App';
import store from './store';
import router from './router';
import versionReporter from './utils/versionReporter';
import logger from './utils/debugLogger';
import './services';

versionReporter.reportVersion();
versionReporter.injectVersion(window);
store.dispatch('account/initialiseAccount');
store.dispatch('agreement/initialise');

// Vue render initialisation
Vue.config.productionTip = false;
// Set up sw communication
window.displaySWUpdateDialogue = () => {
  Vue.prototype.$msgbox({
    title: 'Update available',
    message: 'An update is available for Viddsee Creator. Refresh the page to get the latest update.',
    showCancelButton: true,
    confirmButtonText: 'Refresh',
    cancelButtonText: 'Cancel',
  })
    .then((action) => {
      if (action === 'confirm') {
        location.reload();
      }
    })
    .catch(() => {
      logger.track.error('User refused to refresh page when received new service worker.');
      window.userRefusedToUpdate = true;
    });
};

// Set up error logging service
Vue.config.errorHandler = logger.errorHandler;
window.addEventListener('unhandledrejection', (event) => {
  Vue.config.errorHandler.call(this, event, this, event.reason);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js